import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Slider from 'antd/lib/slider';
import { percentageFormatter } from '../../../../common/utils/helpers';

@translate()
export default class Interest extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    value: [],
  };

  componentDidMount() {
    this.setState({
      value: [this.props.min, this.props.max],
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value[0] !== nextProps.value[0] || this.state.value[1] !== nextProps.value[1]) {
      this.setState({
        value: [nextProps.value[0], nextProps.value[1]],
      });
    }
  }

  onChange = value => {
    this.setState({ value });
  };

  onAfterChange = ([interestMin, interestMax]) =>
    this.props.onChange({
      interestMin,
      interestMax,
    });

  render() {
    const { t, min, max, step } = this.props;
    const { value } = this.state;

    return (
      <div className="filter interest-filter slider-filter">
        <span>
          {t('Rozsah úroku')}: {percentageFormatter(value[0])} - {percentageFormatter(value[1])}
        </span>
        <Slider
          range
          min={min}
          max={max}
          step={step}
          value={value}
          tipFormatter={percentageFormatter}
          onChange={this.onChange}
          onAfterChange={this.onAfterChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/filters/Interest.js